import JobDurationEditor from './JobDurationEditor';

class QueuedJobDurationEditor extends JobDurationEditor {
  constructor(name, options) {
    super(name, {
      getJobDurationStart: options.jobService.getJobQueuedAt.bind(options.jobService),
      getJobDurationEnd: job => (options.jobService.getJobStartedAt(job) || options.jobService.getJobEndedAt(job)),
      ...options,
    });
  }
}

export { JobDurationEditor, QueuedJobDurationEditor };
